import React from 'react'

const SingleFilter = ({ isChecked, onChange, value, title }) => {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input checked={isChecked} style={{width:"16px"}} onChange={onChange} value={value} type={"checkbox"} className="input-checkbox" />
            <span style={{fontSize:"15px",fontWeight:500}}>{title}</span>
        </div>
    )
}

export default SingleFilter